import { render, staticRenderFns } from "./ShipstationWebhooks.vue?vue&type=template&id=1dd1cc2a&"
import script from "./ShipstationWebhooks.vue?vue&type=script&lang=js&"
export * from "./ShipstationWebhooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports